import styled from "@emotion/styled";
import { Checkbox } from "office-ui-fabric-react";

export const FormCheckbox = styled(Checkbox)<{ background?: string }>`
  margin: 10px 0;
  .ms-Checkbox-checkbox {
    background-color: ${p => p.background ?? undefined};
  }
  .ms-Checkbox-label {
    font-weight: 600;
  }
`;
